export const getApiUrl = (): string => {
  const apiUrl = JSON.parse(
    sessionStorage.getItem('api_url')!
  )?.REACT_APP_API_URL;

  return apiUrl;
};

export const getTbmsParams = (): {
  tbmsPortalUrl: string;
} => {
  const tbmsPortalUrl = JSON.parse(
    sessionStorage.getItem('api_url')!
  )?.TBMS_POST_URL;

  return { tbmsPortalUrl };
};

export const getStrapiUrl = (): string => {
  const apiUrl = JSON.parse(sessionStorage.getItem('api_url')!)?.STRAPI_API_URL;

  return apiUrl;
};

export const getAuthConfig = (): {
  clientId: string;
  tenantId: string;
  azureScopes: Array<string>;
} => {
  const clientId = JSON.parse(
    sessionStorage.getItem('api_url')!
  )?.AZURE_CLIENT_ID;

  const tenantId = JSON.parse(
    sessionStorage.getItem('api_url')!
  )?.AZURE_TENANT_ID;

  const azureScopes = JSON.parse(
    sessionStorage.getItem('api_url')!
  )?.AZURE_SCOPES;

  return { clientId, tenantId, azureScopes };
};
